import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/config/site";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
}

export const SEO = ({
  title,
  description,
  path = "/",
  image = "/Babblegram-1.png",
  jsonLd,
}: SEOProps) => {
  const canonical = `${SITE_URL}${path}`;
  const absImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={absImage} />
      <meta property="og:image:alt" content={`${title} — BabbleGram daily word puzzle game`} />
      <meta property="og:site_name" content="BabbleGram" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />
      <meta name="twitter:image:alt" content={`${title} — BabbleGram daily word puzzle game`} />

      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
